import { ReceiptFacts, ReceiptPaymentKindText, StatusMessage } from '@krp/ui-kit'
import { formatDateTime, formatMoney } from '../../pricing/model/format'
import { CashReceiptGoods, type CashReceiptLinesProps } from './CashReceiptLines'

export type CashReceiptDetailProps = CashReceiptLinesProps

/** Окно чека 1С: шапка таблицей «подпись — значение», ниже товары чека — те же, что в раскрытой строке списка. */
export function CashReceiptDetailScreen({ data, error, openProduct, photoOf }: CashReceiptDetailProps) {
  if (error !== null) return <StatusMessage kind="error" title="Не удалось прочитать чек" text={error} />
  if (data === undefined) return <StatusMessage kind="loading" title="Читаем исходный чек…" />
  const receipt = data.receipt
  const cash = receipt.amount === null || receipt.cardAmount === null ? null : Math.round((receipt.amount - receipt.cardAmount) * 100) / 100
  return <section className="onec-screen" aria-label="Исходный чек 1С">
    <ReceiptFacts label="Реквизиты чека" facts={[
      { label: 'Вид', value: receipt.kind === 'refund' ? 'Возврат' : 'Приход' },
      { label: 'Номер', value: receipt.receiptNumber ?? receipt.number ?? 'без номера' },
      { label: 'Дата и время', value: formatDateTime(receipt.date) },
      { label: 'Касса', value: receipt.registerName ?? 'не указана' },
      { label: 'Кассир', value: receipt.cashierName ?? 'не указан' },
      { label: 'Смена', value: receipt.shiftNumber ?? 'не указана' },
      { label: 'Оплата', value: <ReceiptPaymentKindText cash={cash} card={receipt.cardAmount} /> },
      { label: 'Наличными', value: formatMoney(cash) },
      { label: 'Картой', value: formatMoney(receipt.cardAmount) },
      { label: 'Итого', value: formatMoney(receipt.amount) },
      { label: 'Состояние', value: [receipt.status, receipt.posted ? 'проведён' : 'не проведён'].filter((part) => part !== null).join(' · ') },
    ]} />
    <CashReceiptGoods data={data} openProduct={openProduct} photoOf={photoOf} />
  </section>
}
